import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVert from '@material-ui/icons/MoreVert';

import { injectIntl, MonthlyInvoicesCard, SmartDialog } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import {
  getMonthlyPurchases,
  getMonthlyPurchasesList,
  getMonthlySales,
  getMonthlySalesList,
} from 'redux/orders/actions';
import { selectState } from 'redux/selectors';

class MonthlyInvoices extends Component {
  static contextTypes = {
    isRestaurant: PropTypes.bool,
    isFarmer: PropTypes.bool,
  };

  static propTypes = {
    isPurchase: PropTypes.bool,
    monthlySalesList: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    monthlyPurchasesList: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    getMonthlyPurchases: PropTypes.func.isRequired,
    getMonthlyPurchasesList: PropTypes.func.isRequired,
    getMonthlySales: PropTypes.func.isRequired,
    getMonthlySalesList: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isPurchase: false,
    monthlyPurchasesList: [],
    monthlySalesList: [],
  };

  state = {
    anchorEl: null,
    item: null,
  };

  componentWillMount() {
    const {
      getMonthlyPurchasesList,
      getMonthlySalesList,
      isPurchase,
    } = this.props;

    if (isPurchase) {
      getMonthlyPurchasesList();
    } else {
      getMonthlySalesList();
    }
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSelect = (item) => {
    this.setState({ item });
    this.handleClose();
  };

  render() {
    const { isRestaurant, isFarmer } = this.context;
    const {
      isPurchase,
      getMonthlyPurchases,
      getMonthlySales,
      monthlyPurchasesList,
      monthlySalesList,
      formatMessage,
    } = this.props;
    const { anchorEl, item } = this.state;
    const id = isPurchase ? 'monthly-invoice-purchase-menu' : 'monthly-invoice-sales-menu';
    const list = isPurchase ? monthlyPurchasesList : monthlySalesList;
    if ((isRestaurant && !isPurchase) || (isFarmer && isPurchase)) return null;
    return (
      <Fragment>
        <Button
          aria-owns={anchorEl ? id : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ color: '#4694EB', padding:'8px' }}
        >
          {isPurchase ? formatMessage('Purchase History') : formatMessage('Sales History')}
          <MoreVert />
        </Button>
        <Menu
          id={id}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {list.map((item, index) => (
            <MenuItem
              onClick={() => this.handleSelect(item)}
              key={index}
            >
              {moment(item.monthYear).format('MMM YYYY')}
            </MenuItem>
          ))}
        </Menu>
        {item && (
          <SmartDialog
            onClose={() => this.handleSelect(null)}
            open
            noFrame
          >
            <MonthlyInvoicesCard
              expanded
              getMonthlyPurchases={getMonthlyPurchases}
              getMonthlySales={getMonthlySales}
              index={0}
              info={item}
              key={item.monthYear}
              noIcon
              reportType={isPurchase ? 'monthlyinvoicepurchase' : 'monthlyinvoicesales'}
            />
          </SmartDialog>
        )}
      </Fragment>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'monthlyPurchasesList')(state),
  ...selectState('orders', 'monthlySalesList')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  getMonthlyPurchases: payload => dispatch(getMonthlyPurchases(payload)),
  getMonthlyPurchasesList: payload => dispatch(getMonthlyPurchasesList(payload)),
  getMonthlySales: payload => dispatch(getMonthlySales(payload)),
  getMonthlySalesList: payload => dispatch(getMonthlySalesList(payload)),
});

export default compose(
  setDisplayName('MonthlyInvoices'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
  injectIntl,
)(MonthlyInvoices);
